<div
  class="tournament-info-card"
  [ngClass]="[variant(), isDisabled() ? 'disabled' : '']"
  [class.active]="activeState() === 'active'"
  [class.compact]="isCompact()"
  [ngStyle]="cardStyle() | theme"
>
  @if (splicedBg && variant() === "full") {
    <app-spliced-background
      [image]="splicedBg.imageUrl"
      [cornerSize]="splicedBg.cornerSize"
      [disabled]="isDisabled()"
    />
  }

  <!-- Shared by both layouts: the prize pool, the subtitle and the Results / Play buttons. -->
  <ng-template #prizePoolBlock>
    <div [ngStyle]="prizePoolLabelStyles() | theme">
      {{ prizePoolLabel }}
    </div>
    <div class="prize-container">
      @if (totalPrizePool().icon && totalPrizePool().iconPosition === "start") {
        <app-currency-icon [icon]="totalPrizePool().icon!" sizeCss="--icon-medium" />
      }
      <div class="prize-stack">
        @if (hasPrizeShadow()) {
          <div [ngStyle]="prizePoolShadowStyles() | theme" class="prize-shadow">
            {{ totalPrizePool().text }}
          </div>
        }
        <div [ngStyle]="prizePoolValueStyles() | theme" class="prize-text">
          {{ totalPrizePool().text }}
        </div>
      </div>
      @if (totalPrizePool().icon && totalPrizePool().iconPosition === "end") {
        <app-currency-icon [icon]="totalPrizePool().icon!" sizeCss="--icon-medium" />
      }
    </div>
  </ng-template>

  <ng-template #subtitleLine>
    @if (subtitle(); as text) {
      <div [class.compact-subtitle]="isCompact()" [ngStyle]="subtitleStyles() | theme">
        {{ text }}
      </div>
    }
  </ng-template>

  <ng-template #actionButtons>
    @if (showButtons()) {
      <div class="buttons" [class.compact-buttons]="isCompact()">
        <app-button
          [label]="resultsButtonLabel"
          variant="secondary"
          [size]="buttonSize()"
          stretch="fill"
          (clickEvent)="onViewClick()"
          class="button-secondary"
        />
        @if (activeState() === "active") {
          <app-button
            [label]="playButtonLabel()"
            [primaryAmount]="playButtonAmount()"
            variant="primary"
            [size]="buttonSize()"
            stretch="fill"
            [disabled]="paymentInFlight()"
            (clickEvent)="onPlayClick()"
            class="button-primary"
          />
        }
      </div>
    }
  </ng-template>

  @if (isCompact()) {
    <!-- The card itself takes no taps: only ⓘ, Results and Play do. -->
    <div class="compact-info">
      <div class="compact-status" [ngStyle]="compactStatusStyles | theme">
        @if (status() === "ACCEPTING_SCORES") {
          <span class="live-dot"></span>
        }
        <span>{{ compactStatus() }}</span>
      </div>
      <div class="compact-title" [ngStyle]="compactTitleStyles | theme">
        {{ compactTitle() }}
      </div>
      <ng-container *ngTemplateOutlet="subtitleLine" />
      @if (userScoreItem(); as score) {
        <div class="compact-score" [ngStyle]="compactSubtitleStyles | theme">
          {{ score.label }}: {{ score.value }}
        </div>
      }
    </div>

    <div class="compact-prize">
      <button class="compact-question-icon" (click)="onTutorialClick()">
        <app-icon icon="question-circle" [colorCss]="iconInfoColor" sizeCss="--icon-medium" />
      </button>
      <ng-container *ngTemplateOutlet="prizePoolBlock" />
    </div>

    <ng-container *ngTemplateOutlet="actionButtons" />
  } @else {
    @if (showButtons()) {
      <button class="question-icon" (click)="onTutorialClick()">
        <app-icon icon="question-circle" [colorCss]="iconInfoColor" sizeCss="--icon-medium" />
      </button>
    }

    <app-mode-pill mode="tournament" [label]="pillLabel()" [state]="activeState()" />

    <div class="info-titles">
      <ng-container *ngTemplateOutlet="prizePoolBlock" />
      <ng-container *ngTemplateOutlet="subtitleLine" />
    </div>

    <div class="info-items">
      @for (config of infoItems(); track config.label) {
        <app-tournament-info-item [config]="config" />
      }
    </div>

    <ng-container *ngTemplateOutlet="actionButtons" />
  }
</div>
